import { DialogContent } from '@material-ui/core';
import cx from 'classnames';

// @ts-expect-error - no TypeScript definitions yet
import { CustomDialog } from 'src/components/CustomDialog';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { formatDateMed } from 'src/lib/format';

import styles from './SubscriptionPausedWall.module.scss';
import { useHandlers } from './useHandlers';
import { useViewState } from './useViewState';

// Must stay below ProfileButton's z-index 41 so a paused user can still log out. MUI would
// otherwise apply theme.zIndex.modal (1300); only an inline style reliably beats its own class.
const WALL_STYLE = { zIndex: 40 };

interface SubscriptionPausedWallProps {
  className?: string;
}

export const SubscriptionPausedWall = ({ className }: SubscriptionPausedWallProps) => {
  const { customerId, isPaused, pauseEndAt } = useViewState();
  const { resuming, handleResume } = useHandlers({ customerId });

  if (!isPaused) {
    return null;
  }

  return (
    <CustomDialog
      className={cx(styles.root, className)}
      open
      style={WALL_STYLE}
      title="Your subscription is paused"
      maxWidth="lg"
      data-testid="subscriptionPausedWall"
      disableEscapeKeyDown
      onSubmit={handleResume}
      submitLabel="Resume now"
      submitProps={{ 'data-testid': 'subscriptionPausedWallResumeButton' }}
      loading={resuming}
      disabled={resuming}
    >
      <DialogContent className={styles.content}>
        <CustomTypography variant={TYPOGRAPHY_VARIANT.paragraph16}>
          {pauseEndAt
            ? `Your account is paused until ${formatDateMed(pauseEndAt)}. Resume now to get instant access to Anyword.`
            : 'Your account is paused. Resume now to get instant access to Anyword.'}
        </CustomTypography>
      </DialogContent>
    </CustomDialog>
  );
};
